<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 44"
      size="small"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <b-button
            size="sm"
            variant="outline-success"
            @click="() => (visible = true)"
          >
            <b-icon-plus></b-icon-plus>
            {{ $l('form_add_btn') || '新增' }}
          </b-button>
        </slot>
      </template>
      <template v-slot:defaultImgUrl="{ row }">
        <b-avatar
          :src="row.scoreImgUrl ? $osscdn(row.scoreImgUrl) : ''"
        ></b-avatar>
        <span class="ml-3">{{ row.scoreByName }}</span>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="showDetail(row.visitScoreCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-show="row.isOwner === 'Y'"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="openDetail(row.visitScoreCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-show="row.isOwner === 'Y'"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.visitScoreCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
    <pagination
      :current-page="page.curPage"
      :page-size="page.pageSize"
      :page-total="page.pageTotal"
      size="small"
      align="right"
      slot="pager"
      @change="handlePaginationChange"
    />
    <add-score-dialog
      :visible="visible"
      :scmCode="scmCode"
      @colse="() => (visible = false)"
    />
    <el-dialog
      ref="formDialog"
      :title="formOption.title"
      :visible.sync="formOption.dialogFormVisible"
      :close-on-click-modal="false"
      width="800px"
    >
      <score-detail :visitScoreCode="curVisitScoreCode"></score-detail>
    </el-dialog>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import AddScoreDialog from './components/add-score-dialog.vue'
import ScoreDetail from './components/detail.vue'
export default {
  mixins: [TableAutoHeight],
  props: {
    scmCode: {
      type: String,
    },
    tablePage: {
      default: () => {},
      type: Object,
    },
  },
  components: { AddScoreDialog, ScoreDetail },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.getData(),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          type: 'seq',
          fixed: 'left',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.label_operation') || '操作',
          align: 'center',
          width: 120,
          fixed: 'left',
          slots: {
            default: 'opt',
          },
        },
        {
          field: 'scoreByName',
          width: 200,
          title: this.$l('appraise_form_label_evaluator') || '评分人',
          headerAlign: 'center',
        },
        {
          align: 'center',
          field: 'scoreTime',
          width: 180,
          title: this.$l('appraise_table_label_evaluation_time') || '评分时间',
        },
        {
          field: 'score',
          width: 120,
          align: 'center',
          title: this.$l('appraise_table_label_score') || '得分',
        },
        {
          field: 'appraisalBillName',
          minWidth: 250,
          title: this.$l('label_appraisal_bill_name') || '评分模板',
          headerAlign: 'center',
        },
        {
          field: 'visitDate',
          align: 'center',
          width: 120,
          title: this.$l('table_visit_label_visitDate') || '拜访日期',
          headerAlign: 'center',
        },
        {
          field: 'visitTitle',
          minWidth: 300,
          title: this.$l('visit_label_visitTitle') || '拜访目的',
          headerAlign: 'center',
        },
      ],
      loading: false,
      tableData: [],
      page: {
        curPage: 1,
        pageSize: 5,
        pageTotal: 0,
      },
      visible: false,
      curVisitScoreCode: '',
      formOption: {
        title: '',
        dialogFormVisible: false,
      },
    }
  },
  watch: {
    scmCode: {
      handler() {
        this.getData()
      },
      immediate: true,
    },
  },
  methods: {
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.$nextTick(() => {
        this.getData()
      })
    },
    getData() {
      if (!this.scmCode) return
      this.loading = true
      this.$api
        .visitScoreListApi({ scmCode: this.scmCode, ...this.page })
        .then((res) => {
          this.loading = false
          this.page.pageTotal = res.body.count
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    showDetail(visitScoreCode) {
      this.curVisitScoreCode = visitScoreCode
      this.formOption.title = '评分记录'
      this.formOption.dialogFormVisible = true
    },
    openDetail(visitScoreCode) {
      this.$router.push({
        name: 'personal-myScmInfo-myVisit-rating-edit',
        params: {
          pageType: 'edit',
          visitScoreCode: visitScoreCode,
        },
      })
    },
    del(code) {
      let msg = this.$l('INDEX.tips_question_delete') || '是否删除?'

      this.$confirm(msg, this.$l('INDEX.tips_question_title') || '提示', {
        confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
        cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
        type: 'warning',
      }).then(() => {
        this.$api.delVisitScoreApi({ visitScoreCode: code }).then(() => {
          this.$message.success(this.$l('INDEX.tips_operate_ok') || '操作成功!')
          this.getData()
        })
      })
    },
  },
}
</script>
